module.exports = __webpack_public_path__ + "img/acqua-palace_drop.48cef5ff.jpeg";